<template>
	<div class="customized-nav" :style="`backgroundColor: ${setData.backgroundColor};`">
		<div :class="`navs-box ${classNameType}`">
			<div class="nav-item" v-for="(item, index) in contentData" :key="index" @click="$jump(item.link)">
				<img class="img" :src="item.address" alt="" />
				<span class="text" :style="`color: ${setData.textColor};`">
					{{ item.name }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: '',
	components: {},
	props: {
		contentData: {
			type: Array,
			default: () => {
				return []
			},
		},
		setData: {
			type: Object,
			default: () => {
				return {
					showType: 'one', // 展示方式 one two
					textColor: '#333', // 文字颜色
					backgroundColor: '#fff', // 背景颜色
					topSpace: 'small', // 上边距 small medium big
					bottomSpace: 'small', // 下边距 small medium big
				}
			},
		},
	},
	data() {
		return {
			classNameType: `showType-${this.setData.showType} topSpace-${this.setData.topSpace} bottomSpace-${this.setData.bottomSpace}`,
		}
	},
	created() { },
	methods: {},
}
</script>

<style lang="less" scoped>
.customized-nav {
	font-size: 0;
	width: 100%;
	overflow-x: scroll;

	.navs-box {
		padding: 0 12px 4px;
		display: flex;

		.nav-item {
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;

			.img {
				width: 40px;
				height: 40px;
			}

			.text {
				margin-top: 6px;
				width: 70.2px;
				height: 16px;
				font-size: 13px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 16px;
				text-align: center;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}

	.showType-one {
		.nav-item {
			flex: 1;
			min-width: 82px;
			max-width: 87.7px;
		}
	}

	.showType-two {
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;

		.nav-item {
			width: 70.2px;
		}

		.nav-item:nth-child(-n + 5) {
			margin-bottom: 14px;
		}
	}

	.topSpace-medium {
		padding-top: 10px;
	}

	.topSpace-big {
		padding-top: 15px;
	}

	.bottomSpace-medium {
		padding-bottom: 10px;
	}

	.bottomSpace-big {
		padding-bottom: 15px;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/customize/customizedComponents/Nav.vue